export const GET_RTB_STATS = 'GET_RTB_STATS';
export const GET_RTB_ERROR_STATS = 'GET_RTB_ERROR_STATS';
export const GET_CAMPAIGN_RTB_STATS = 'GET_CAMPAIGN_RTB_STATS';
export const GET_CAMPAIGN_RTB_FAIL_REASONS = 'GET_CAMPAIGN_RTB_FAIL_REASONS';
export const GET_CAMPAIGN_RTB_STATS_FOR_PUBLISHER = 'GET_CAMPAIGN_RTB_STATS_FOR_PUBLISHER';
export const GET_CAMPAIGN_RTB_FAIL_REASONS_FOR_PUBLISHER = 'GET_CAMPAIGN_RTB_FAIL_REASONS_FOR_PUBLISHER';